import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import AccountListEntity from '../entity/account-list';
import { PasswordEntity } from '../entity/password';
import { BindUserInfoObjectValue } from '../value-object/user-info/bind-user-info';
import { OfficialInfoObjectValue } from '../value-object/user-info/official-info';
import { VipUserInfoObjectValue } from '../value-object/user-info/vip-user-info';
import { AccountRepository } from '../../repository/account';
import { Aggregate } from '../../../base/ddd-types/aggregate';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
import { max } from 'lodash-es';
import { BaseUserInfoObjectValue } from '../value-object/user-info/base-user-info';
var AccountAggregate = /** @class */ (function (_super) {
    __extends(AccountAggregate, _super);
    function AccountAggregate(networkRequestService, tinyId, userInfo) {
        var _this = _super.call(this, tinyId) || this;
        _this.networkRequestService = networkRequestService;
        _this.userInfo = new BaseUserInfoObjectValue();
        _this.vipInfo = new VipUserInfoObjectValue();
        _this.bindUserInfo = new BindUserInfoObjectValue();
        _this.officialInfo = new OfficialInfoObjectValue();
        _this.userInfo = new BaseUserInfoObjectValue(userInfo);
        _this.accountListEntity = new AccountListEntity(networkRequestService, tinyId);
        _this.passwordEntity = new PasswordEntity(networkRequestService, tinyId);
        _this.accountRepository = new AccountRepository(networkRequestService);
        return _this;
    }
    AccountAggregate.prototype.completionUserInfo = function (userInfo) {
        if (userInfo.wechatOfficialAccount) {
            this.officialInfo = new OfficialInfoObjectValue(userInfo.wechatOfficialAccount);
        }
        this.bindUserInfo = new BindUserInfoObjectValue(userInfo);
    };
    AccountAggregate.prototype.completionVipInfo = function (vipInfo) {
        this.vipInfo.updateVipUserInfo(vipInfo);
    };
    AccountAggregate.prototype.updateNowUserIndex = function (userIndex) {
        if (!userIndex) {
            return;
        }
        window.nowUserIndex = userIndex;
    };
    /**
     * 获取当前登录的账号的绑定信息
     */
    AccountAggregate.prototype.currentLoginAccountBindInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, currentAccountBindInfo;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.accountRepository.CurrentLoginAccountBindInfo()];
                    case 1:
                        response = _b.sent();
                        currentAccountBindInfo = (_a = response.resData) === null || _a === void 0 ? void 0 : _a.data;
                        if (!currentAccountBindInfo) {
                            return [2 /*return*/, {
                                    allowBind: false,
                                    allowUnbind: false,
                                    nextAllowBindTime: 0,
                                    nextAllowUnbindTime: 0,
                                    autoRenewal: false,
                                }];
                        }
                        return [2 /*return*/, currentAccountBindInfo];
                }
            });
        });
    };
    AccountAggregate.prototype.bindingQQInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, shouldAddUFlag, currentAccountResponse, bingingAccountResponse, currentAccountData, bingingAccountData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        loginType = this.userInfo.loginType;
                        shouldAddUFlag = ![ACCOUNT_TYPE.QQ, ACCOUNT_TYPE.WX].includes(loginType);
                        return [4 /*yield*/, this.accountRepository.CurrentLoginAccountBindInfo()];
                    case 1:
                        currentAccountResponse = _c.sent();
                        return [4 /*yield*/, this.accountRepository.BindingAccountInfo(shouldAddUFlag)];
                    case 2:
                        bingingAccountResponse = _c.sent();
                        currentAccountData = (_a = currentAccountResponse.resData) === null || _a === void 0 ? void 0 : _a.data;
                        bingingAccountData = (_b = bingingAccountResponse.resData) === null || _b === void 0 ? void 0 : _b.data;
                        // 如果数据出现空的就返回数据
                        if (!currentAccountData || !bingingAccountData) {
                            return [2 /*return*/, {
                                    isCanBind: false,
                                    nextBindTime: 0,
                                    qqAvatar: '',
                                    qqNickName: '',
                                }];
                        }
                        return [2 /*return*/, {
                                isCanBind: currentAccountData.allowBind && bingingAccountData.allowBind,
                                nextBindTime: max([currentAccountData.nextAllowBindTime, bingingAccountData.nextAllowBindTime]),
                                qqNickName: bingingAccountData.nick,
                                qqAvatar: bingingAccountData.avatar,
                            }];
                }
            });
        });
    };
    AccountAggregate = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String, Object])
    ], AccountAggregate);
    return AccountAggregate;
}(Aggregate));
export default AccountAggregate;
